var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "my-info-update-page" }, [
        _c("div", { staticClass: "stepStyle" }, [_vm._v("第一步：")]),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v("请确保注册时个人信息正确"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [_vm._v("信息通过后不可更改")]),
        _vm._v(" "),
        _c("div", { staticClass: "active-block" }, [
          _c("div", { staticClass: "content-line" }, [
            _vm._v("请上传本人的证件照"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "van-uploader",
                {
                  staticClass: "avatar-uploader",
                  attrs: { "after-read": _vm.afterRead_Z },
                },
                [
                  _vm.ZimageUrl
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.ZimageUrl },
                      })
                    : _c("img", {
                        staticClass: "avatar",
                        attrs: { src: require("../../images/icon/3.png") },
                      }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "van-uploader",
                {
                  staticClass: "avatar-uploader",
                  attrs: { "after-read": _vm.afterRead_F },
                },
                [
                  _vm.FimageUrl
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.FimageUrl },
                      })
                    : _c("img", {
                        staticClass: "avatar",
                        attrs: { src: require("../../images/icon/4.png") },
                      }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "prompt" }, [
          _vm._v(
            "\n      *为保证您的权益，请确认下列“姓名”及“身份证号”为本人信息，若存在错误请点击信息进行修改。\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rz-block" }, [
          _c("div", { staticClass: "line-block" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "line-text" }, [
              _c(
                "div",
                [
                  _c("van-field", {
                    attrs: { label: "姓名：", placeholder: "请输入用户名" },
                    model: {
                      value: _vm.userInfo.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "name", $$v)
                      },
                      expression: "userInfo.name",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "line-text" },
              [
                _c("van-field", {
                  attrs: {
                    label: "身份证号：",
                    placeholder: "请输入请输入身份证号",
                  },
                  model: {
                    value: _vm.userInfo.id_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.userInfo, "id_number", $$v)
                    },
                    expression: "userInfo.id_number",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "line-text" },
              [
                _c("van-field", {
                  attrs: {
                    readonly: "",
                    label: "手机号：",
                    placeholder: _vm.userInfo.phone,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.registeredType
              ? _c(
                  "div",
                  {
                    staticClass: "success_button",
                    on: {
                      click: function ($event) {
                        return _vm.up_userinfo()
                      },
                    },
                  },
                  [_vm._v("确认个人信息")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.registeredType
              ? _c(
                  "div",
                  {
                    staticClass: "success_button",
                    on: {
                      click: function ($event) {
                        return _vm.up_userinfo()
                      },
                    },
                  },
                  [_vm._v("修改个人信息")]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stepStyle" }, [_vm._v("第二步：")]),
        _vm._v(" "),
        _c("div", { staticClass: "prompt" }, [
          _vm._v(
            "\n      *为保证您的权益，手机号实名认证需要实名认证的注册手机号为本人实名开通;若手机实名认证失败请选择人脸实名认证。\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.registeredType
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      return _vm.RZ()
                    },
                  },
                },
                [_vm._v("手机号实名认证")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      return _vm.RLRZ()
                    },
                  },
                },
                [_vm._v("人脸实名认证")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.registeredType
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "button buttonError",
                  on: {
                    click: function ($event) {
                      return _vm.showError()
                    },
                  },
                },
                [_vm._v("手机号实名认证")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "button buttonError",
                  on: {
                    click: function ($event) {
                      return _vm.showError()
                    },
                  },
                },
                [_vm._v("人脸实名认证")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.show_certificate
          ? _c("div", { staticClass: "prompt" }, [
              _vm._v("\n      *数字证书与实名认证申请成功\n    "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: {
            "show-cancel-button": "",
            "before-close": _vm.beforeClose,
            "confirm-button-text": "下一步",
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _vm.company == ""
            ? _c("div", [_c("ComponentA")], 1)
            : _c("div", [_c("ComponentB")], 1),
        ]
      ),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: {
            "show-cancel-button": false,
            "show-confirm-button": false,
            "before-close": _vm.phonebeforeClose,
            "confirm-button-text": "确认",
          },
          model: {
            value: _vm.phoneisShow,
            callback: function ($$v) {
              _vm.phoneisShow = $$v
            },
            expression: "phoneisShow",
          },
        },
        [
          _c("div", { staticClass: "dialog-block" }, [
            _c("div", { staticClass: "line-block-phone" }, [
              _c("div", { staticClass: "line-block-phone-title" }, [
                _vm._v("手机验证"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line-block-phone-input" }, [
                _c(
                  "div",
                  {
                    staticClass: "tishi",
                    staticStyle: { "margin-bottom": "0.2rem" },
                  },
                  [
                    _vm._v(
                      "\n            *请首先点击获得验证码，获得验证码后填入验证码，进行实名认证的操作\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-block" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入验证码", maxlength: "6" },
                      model: {
                        value: _vm.input_phone_code,
                        callback: function ($$v) {
                          _vm.input_phone_code = $$v
                        },
                        expression: "input_phone_code",
                      },
                    }),
                    _vm._v(" "),
                    _vm.activeshow
                      ? _c(
                          "el-button",
                          {
                            staticClass: "input-button",
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.huode_code()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.showcodetext))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.activeshow
                      ? _c(
                          "el-button",
                          {
                            staticClass: "input-button",
                            attrs: { type: "success", disabled: true },
                            on: {
                              click: function ($event) {
                                return _vm.huode_code()
                              },
                            },
                          },
                          [_vm._v("重新发送" + _vm._s(_vm.count) + "秒")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rm-code" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "sm-button",
                        attrs: { type: "success" },
                        on: {
                          click: function ($event) {
                            return _vm.yanzheng_code()
                          },
                        },
                      },
                      [_vm._v("确认")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "line-block-pram" }, [
      _c("img", {
        staticClass: "card-icon-img",
        attrs: { src: require("../../images/icon/2.png"), alt: "" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "lx-font" }, [_vm._v("实名认证信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }